import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Stack, TableCell, Typography, DialogContentText } from '@mui/material';
import { TableWidgetV2, CustomFilterV2, DialogDefaultV2 } from '../../../components/v2';
import * as selectorsControlePontos from '../../../store/controlePonto/reducer';
import * as actionsControlePontos from '../../../store/controlePonto/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Roles from '../../../constants/role';
import Formulario from './Formulario';

const ControlePontoV2 = ({ controlePontoUsuarios, loadControlePontoUsuarios, authData, exportControlePonto }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState({ ativo: true });
  const [openExport, setOpenExport] = useState(false);

  useEffect(() => {
    loadControlePontoUsuarios(localFilter);
  }, [loadControlePontoUsuarios]);

  const isAdmin = authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const onEdit = (rowId) => {
    setId(rowId);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setId(null);
    loadControlePontoUsuarios(localFilter);
  };

  const renderRows = (r) => (
    <>
      <TableCell>
        <Typography variant="body2">{r.nome}</Typography>
        <Typography variant="body2" color="text.secondary">{r.matricula}</Typography>
      </TableCell>
      <TableCell>{r.ativo ? 'Sim' : 'Não'}</TableCell>
      <TableCell>{r.saldo}</TableCell>
    </>
  );

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={3}>
        <CustomFilterV2
          variant="dialog"
          filterData={localFilter}
          onFilter={(filterData) => {
            setLocalFilter(filterData);
            loadControlePontoUsuarios(filterData);
          }}
          fields={[
            { field: 'useInspetor', multiSelect: true, md: 8, label: 'Usuário' },
            { field: 'useAtivo', useAtivoLabel: 'Usuário Ativo' },
          ]}
        />
        <TableWidgetV2
          rows={controlePontoUsuarios || []}
          titles={['Nome', 'Ativo', 'Saldo']}
          headerTitle="Controle de Ponto"
          renderRows={renderRows}
          hasAdd={false}
          showDelete={false}
          showEdit
          hasRowActions={isAdmin}
          onEdit={onEdit}
          headerActions={[{ title: 'Exportar', onClick: () => setOpenExport(true) }]}
        />
      </Stack>
      <Formulario id={id} open={open} onClose={onClose} />
      <DialogDefaultV2
        open={openExport}
        handlerCancel={() => setOpenExport(false)}
        handlerConfirm={() => exportControlePonto(localFilter, () => setOpenExport(false))}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>Deseja exportar todas as informações filtradas?</DialogContentText>
      </DialogDefaultV2>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  controlePontoUsuarios: selectorsControlePontos.getControlePontosUsuarios(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsControlePontos }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ControlePontoV2);
